import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import netherlandsFlag from "../images/netherlands.png";
import unitedKingdomFlag from "../images/united-kingdom.png";
import { update_admin } from "../reduxData/user/userAction";
import { useDispatch, useSelector } from "react-redux";


const LanguageSwitcher = () => {
  const dispatch = useDispatch()
  const { i18n } = useTranslation();
  const { userDetails, accessToken } = useSelector((state) => state.auth);

  const languages = [
    { code: "nl", label: "NL", short: "NL", flag: netherlandsFlag },
    { code: "en", label: "ENG", short: "EN", flag: unitedKingdomFlag },
  ];

  const activeLanguage = (i18n.resolvedLanguage || i18n.language || "nl")
    .split("-")[0]
    .toLowerCase();
  const currentLang = languages.find((lang) => lang.code === activeLanguage) || languages[0];

  const passLanguageToUser = async (selectedLang) => {
    if (!accessToken) return;
    try {
      await update_admin(
        { selected_language: selectedLang },
        dispatch,
        { reload: false, showToast: false }
      );
    } catch (error) {
      console.error("Failed to update language", error);
    }
  };


  useEffect(() => {
    const userLanguage = userDetails?.selected_language;
    const savedLang = localStorage.getItem("language");
    // const browserLang = getBrowserLanguage();
    const browserLang = 'nl'
    const languageToUse = userLanguage || savedLang || (["en", "nl"].includes(browserLang) ? browserLang : "nl");
    i18n.changeLanguage(languageToUse);
    document.documentElement.lang = languageToUse;
    localStorage.setItem("language", languageToUse);
  }, [i18n, userDetails?.selected_language]);

  const handleChange = async (e) => {
    const selectedLang = e.target.value;
    i18n.changeLanguage(selectedLang).then(() => {
      localStorage.setItem("language", selectedLang);
      document.documentElement.lang = selectedLang;
      passLanguageToUser(selectedLang)
    });
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.overflowX = "hidden";
    };
  }, []);

  return (
    <div className="language-switcher-wrapper">
      <div className="language-selected-display" aria-hidden="true">
        <img
          src={currentLang.flag}
          alt={`${currentLang.short} flag`}
          className="language-flag-img"
        />
        <span className="language-label">{currentLang.short}</span>
      </div>
      <select
        onChange={handleChange}
        value={currentLang.code}
        className="language-select"
        aria-label="Select language"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code} className="language-option">
            {lang.label}
          </option>
        ))}
      </select>

      <i className="bi bi-chevron-down language-dropdown-icon" aria-hidden="true"></i>
    </div>
  );
};

export default LanguageSwitcher;
